import { render, staticRenderFns } from "./OTotalesDetailPurchaseComp.vue?vue&type=template&id=13273bb2&"
import script from "./OTotalesDetailPurchaseComp.vue?vue&type=script&lang=js&"
export * from "./OTotalesDetailPurchaseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports